import axios from "axios";

import { FilterResponse, RequestFilter } from "./generatedTypes";

export default {
  filter: (filterData?: RequestFilter) => {
    return axios.post<FilterResponse>("/filter", filterData);
  },
};
